import { getApolloSearchTerms } from 'legacy/lut/services/partner/partnerDuplicates/helpers/getApolloSearchTerms'
import { getPreparedPartnerDuplicatesData } from 'legacy/lut/services/partner/partnerDuplicates/helpers/getPreparedPartnerDuplicatesData'
import { IApolloSearchParams } from 'legacy/lut/services/partner/partnerDuplicates/models'

import { ICrudFetchOptions } from 'clickNgo/models/crud/utils'
import { apolloService } from 'onboarding/services/apolloService'

export const searchOnboardingPartnerDuplicates = async (
  { partner }: IApolloSearchParams,
  options?: ICrudFetchOptions
) => {
  const apolloSearchTerms = await getApolloSearchTerms(partner)
  const matches = await apolloService.search(apolloSearchTerms)

  return getPreparedPartnerDuplicatesData(
    {
      apolloSearchResult: matches,
      partner,
    },
    options
  )
}
